module.exports = __webpack_public_path__ + "static/pod-main-banner-route-c370b12d79aee4e008cad0a9677f0762.svg";